// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1077":"0b898bdabf7a7887","3125":"8fbe708fb0c4f8d1","7082":"2a59359d4c10a01a"}[chunkId] + ".js";
};